import { render } from "./ChangeDeviceModal.vue?vue&type=template&id=5b856757&scoped=true"
import script from "./ChangeDeviceModal.vue?vue&type=script&lang=js"
export * from "./ChangeDeviceModal.vue?vue&type=script&lang=js"

import "./ChangeDeviceModal.vue?vue&type=style&index=0&id=5b856757&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b856757"]])

export default __exports__